<template>
    <div class="pagination-content">
        <el-pagination
        v-model="current_page"
        layout="prev, pager, next, total, jumper"
        prev-text="上一页"
        next-text="下一页"
        :total="total"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        @prev-click="prevPage"
        @next-click="nextPage"
        />
    </div>
</template>
<script>
export default {
    props: {
        currentPage: Number,
        total: Number,
        pageSize: {
            type: Number,
            default: 10
        }
    },
    data() {
        return {
            current_page: 1
        }
    },
    methods: {
        handleCurrentChange(currentPage) {
            this.$parent.paginationRequestPage(currentPage)
        },
        // 上一页
        prevPage() {
            this.$parent.paginationRequestPage(this.currentPage - 1)
        },
        // 下一页
        nextPage() {
            this.$parent.paginationRequestPage(this.currentPage + 1)
        }
    },
}
</script>
<style scoped>
    .pagination-content {
        /* position: absolute;
        bottom: 20px; */
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pagination-content /deep/ .btn-prev,
    .pagination-content /deep/ .btn-next {
        width: 48px;
        height: 22px;
        border-radius: 4px;
        border: 1px solid #434b5f;
        /* background: none; */
        padding: 0;
        /* background-color: transparent;
        border: 1px solid #434b5f;
        border-radius: 4px;
        color: red; */
    }
    .pagination-content /deep/ .el-pagination button:disabled {
        border: 1px solid rgba(0, 0, 0, 0.3);
    }
    .pagination-content /deep/ .el-pagination button {
        border: 1px solid #005BA3;
    }
    .pagination-content /deep/ .btn-prev span,
    .pagination-content /deep/ .btn-next span {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 400;
        height: 22px;
        width: 48px;
        padding: none;
        /* color: #ffffff; */
        /* opacity: 0.5; */
    }
    .pagination-content /deep/ .el-pagination .el-pager li {
        min-width: 22px;
        height: 22px;
        border: 1px solid #005BA3;
        margin: 0 6px;
        padding: 0;
        font-size: 12px;
        line-height: 22px;
    }
    .pagination-content /deep/ .el-pagination .el-pager li.active {
        color: white;
        background: #005BA3;
        border-radius: 4px;
    }
    .pagination-content /deep/ .el-pagination .el-pagination__total {
        height: 22px;
        font-size: 12px;
        margin: 0 12px;
        line-height: 22px;
    }
    .pagination-content /deep/ .el-pagination .el-pagination__jump {
        margin: 0;
        padding: 0;
        font-size: 12px;
        height: 22px;
        line-height: 22px;
    }
    .pagination-content /deep/ .el-pagination .el-pagination__jump .el-pagination__editor {
        height: 22px;
        line-height: 22px;
    }
    .pagination-content /deep/ .el-pagination .el-pagination__jump .el-pagination__editor input {
        height: 22px;
        border: 1px solid #005BA3;
    }   
</style>